import { useState, useEffect } from 'react'
import { AuthProvider, useAuth } from './hooks/useAuth'
import AuthPage     from './pages/AuthPage'
import AddPage      from './pages/AddPage'
import SummaryPage  from './pages/SummaryPage'
import SettingsPage from './pages/SettingsPage'
import PrivacyPage  from './pages/PrivacyPage'
import LandingPage  from './pages/LandingPage'
import BottomNav    from './components/BottomNav'

function Shell() {
  const { user, loading } = useAuth()
  const [tab, setTab]             = useState('add')
  const [catsVersion, setCatsVersion] = useState(0)
  const [path, setPath]           = useState(window.location.pathname)
  const [showAuth, setShowAuth]   = useState(false)

  useEffect(() => {
    const handlePop = () => setPath(window.location.pathname)
    window.addEventListener('popstate', handlePop)
    return () => window.removeEventListener('popstate', handlePop)
  }, [])

  if (path === '/privacy') return <PrivacyPage />

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F7F4EF' }}>
      <div style={{ fontSize: 40 }}>₹</div>
    </div>
  )

  if (!user) {
    if (showAuth) return <AuthPage onBack={() => setShowAuth(false)} />
    return <LandingPage onLogin={() => setShowAuth(true)} />
  }

  return (
    <div style={{ maxWidth: 480, margin: '0 auto', minHeight: '100vh', background: '#F7F4EF', paddingBottom: 80, fontFamily: "'DM Sans', sans-serif" }}>
      <div style={s.header}>
        <div style={s.logoMark}>₹</div>
        <div>
          <div style={s.appName}>PaisaTrack</div>
          <div style={s.tagline}>Know where every rupee went</div>
        </div>
      </div>

      {tab === 'add'      && <AddPage onAdded={() => {}} catsVersion={catsVersion} />}
      {tab === 'summary'  && <SummaryPage />}
      {tab === 'settings' && <SettingsPage onCatsChanged={() => setCatsVersion(v => v+1)} />}

      <BottomNav active={tab} onChange={setTab} />
    </div>
  )
}

export default function App() {
  return <AuthProvider><Shell /></AuthProvider>
}

const s = {
  header:  { display: 'flex', alignItems: 'center', gap: 12, padding: '1rem 1rem 0.5rem', background: '#F7F4EF' },
  logoMark:{ width: 38, height: 38, background: '#1A1A2E', color: '#E8C547', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, fontWeight: 700, flexShrink: 0 },
  appName: { fontSize: 18, fontWeight: 700, color: '#1A1A2E', letterSpacing: '-0.3px' },
  tagline: { fontSize: 11, color: '#AAA' },
}
